// Erros que o operador entende, no campo, com sinal fraco.
//
// "TypeError: Failed to fetch" não diz ao Flávio que a culpa é do sinal, nem que
// NADA foi alterado. Estas funções são puras (sem React, sem `navigator` no import)
// para serem testadas.

export interface ErroHumano {
  titulo: string;
  descricao: string;
}

/** O formato mínimo de um `ErroApi` — duck-typing, para não importar o client inteiro. */
interface ErroComStatus {
  status?: unknown;
  mensagem?: unknown;
  estadoAtual?: unknown;
}

function ehFalhaDeRede(e: unknown, online: boolean): boolean {
  if (!online) return true;
  if (e instanceof TypeError) return true;
  const texto = e instanceof Error ? e.message : typeof e === "string" ? e : "";
  return /failed to fetch|networkerror|load failed|network request failed|fetch failed/i.test(texto);
}

/**
 * Falha de rede → "Sem sinal. Nada foi alterado."; 5xx → "O servidor não respondeu";
 * 4xx com a frase do servidor → a frase; o resto → genérico (nunca o texto cru de uma
 * exceção).
 */
export function mensagemDeErro(e: unknown, online: boolean = typeof navigator === "undefined" ? true : navigator.onLine !== false): ErroHumano {
  const api = (e ?? {}) as ErroComStatus;
  const status = typeof api.status === "number" ? api.status : null;

  if (status === null && ehFalhaDeRede(e, online)) {
    return { titulo: "Sem sinal", descricao: "Nada foi alterado. Tente de novo." };
  }
  if (status !== null && status >= 500) {
    return { titulo: "O servidor não respondeu", descricao: "Tente de novo." };
  }
  if (status !== null && typeof api.mensagem === "string" && api.mensagem.trim().length > 0) {
    return { titulo: "Não deu certo", descricao: api.mensagem };
  }
  return { titulo: "Não deu certo", descricao: "Tente de novo." };
}

/**
 * 409 cujo `estadoAtual` já é o estado PEDIDO: a operação já está onde a pessoa queria
 * (outra pessoa fez, ou a resposta anterior se perdeu). Tratar como sucesso.
 */
export function jaEstaNoEstadoPedido(e: unknown, estadoPedido: string): boolean {
  const api = (e ?? {}) as ErroComStatus;
  return api.status === 409 && api.estadoAtual === estadoPedido;
}
